import { useEffect, useState } from "react";
import { SECTIONS } from "./data";

const useActiveSection = () => {
  const [active, setActive] = useState(SECTIONS[0].id);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id);
      },
      { rootMargin: "-25% 0px -65% 0px" }
    );
    SECTIONS.forEach((s) => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);
  return active;
};

const scrollTo = (id) => (e) => {
  e.preventDefault();
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  window.history.replaceState(null, "", `#${id}`);
};

export const SideNav = () => {
  const active = useActiveSection();
  const activeIndex = SECTIONS.findIndex((s) => s.id === active);

  useEffect(() => {
    const chip = document.querySelector(`[data-testid="coe-mobilenav-${active}"]`);
    if (chip && chip.offsetParent) chip.scrollIntoView({ inline: "center", block: "nearest" });
  }, [active]);

  return (
    <>
      <nav className="hidden lg:block sticky top-28 self-start" aria-label="On this page" data-testid="coe-sidenav">
        <p className="text-[#5A6578] text-[11px] uppercase tracking-[0.25em] mb-5">On this page</p>
        <div className="relative pl-5">
          <div className="absolute left-0 top-1 bottom-1 w-px bg-[#2A3648]" />
          <div
            className="absolute left-0 w-px bg-[#C9A962] transition-[height] duration-500"
            style={{ top: 4, height: `${((activeIndex + 1) / SECTIONS.length) * 100}%` }}
          />
          <ul className="space-y-1">
            {SECTIONS.map((s, i) => (
              <li key={s.id}>
                <a
                  href={`#${s.id}`}
                  onClick={scrollTo(s.id)}
                  className={`group flex items-center gap-3 py-2 text-sm transition-colors ${active === s.id ? "text-[#A8873E] font-semibold" : "text-[#475569] hover:text-[#A8873E]"}`}
                  data-testid={`coe-sidenav-${s.id}`}
                >
                  <span className={`font-mono text-[10px] ${active === s.id ? "text-[#A8873E]" : "text-[#94A3B8]"}`}>{String(i + 1).padStart(2, "0")}</span>
                  <span className={`coe-nav-label ${active === s.id ? "is-active" : ""}`}>{s.label}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      <nav className="keep-dark lg:hidden sticky top-[68px] z-40 -mx-6 px-6 py-3 bg-[#0A1628]/95 backdrop-blur-md border-b border-[#2A3648] overflow-x-auto" aria-label="On this page" data-testid="coe-mobilenav">
        <ul className="flex gap-2 w-max">
          {SECTIONS.map((s) => (
            <li key={s.id}>
              <a
                href={`#${s.id}`}
                onClick={scrollTo(s.id)}
                className={`block whitespace-nowrap px-3 py-1.5 rounded-full text-xs border transition-colors ${active === s.id ? "bg-[#C9A962] text-[#0A1628] border-[#C9A962] font-semibold" : "border-[#2A3648] text-[#A0ABC0]"}`}
                data-testid={`coe-mobilenav-${s.id}`}
              >
                {s.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};
